export default "__VITE_ASSET__DBiEX4vz__"